import React from 'react'
import styled from 'styled-components'
import { Icon } from '../../../atoms/Icon'

const ToggleButton = styled.button<{ $hidden: boolean }>`
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.default};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  background: ${({ $hidden, theme }) =>
    $hidden
      ? theme.colors.background.secondary
      : theme.colors.background.primary};
  color: ${({ $hidden, theme }) =>
    $hidden ? theme.colors.text.tertiary : theme.colors.text.secondary};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};
  }
`

export interface VisibilityToggleProps {
  isHidden: boolean
  onToggle: () => void
  hideTooltip?: string
  showTooltip?: string
}

/** Eye toggle controlling a metric row's display state (edit mode). */
export const VisibilityToggle: React.FC<VisibilityToggleProps> = ({
  isHidden,
  onToggle,
  hideTooltip = 'Hide this metric',
  showTooltip = 'Show this metric',
}) => (
  <ToggleButton
    type="button"
    $hidden={isHidden}
    onClick={onToggle}
    title={isHidden ? showTooltip : hideTooltip}
    aria-label={isHidden ? showTooltip : hideTooltip}
  >
    <Icon name={isHidden ? 'eye-off' : 'eye'} size="small" />
  </ToggleButton>
)
